import React, {useCallback} from 'react';

import {
  MAX_COL_COUNT,
  MAX_COMPARE_COL_COUNT,
  MIN_COL_COUNT,
  MIN_COMPARE_COL_COUNT,
} from '../../../../PanelMediaBrowser/config';
import {
  useMediaColumnCountDisplay,
  useMediaModeDisplay,
  useShouldShowMediaColumnCountResetAtLevel,
} from '../../hooks';
import {SettingsSliderInput} from '../common/SettingsSliderInput';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const NumberOfColumns = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const mode = useMediaModeDisplay(settingsLevel, panelRef);
  const initialValue = useMediaColumnCountDisplay(settingsLevel, panelRef);
  const isSetAtLevel = useShouldShowMediaColumnCountResetAtLevel(
    settingsLevel,
    panelRef
  );

  // Debounce the updateConfig call so we don't update on every keystroke or slider change
  const updateConfigCallback = useCallback(
    (value: number) => {
      updateConfig({columnCount: value});
    },
    [updateConfig]
  );

  const isCompareMode = mode === 'compare';
  const {min, max} = isCompareMode
    ? {min: MIN_COMPARE_COL_COUNT, max: MAX_COMPARE_COL_COUNT}
    : {min: MIN_COL_COUNT, max: MAX_COL_COUNT};
  return (
    <div className="flex flex-col">
      <SettingTitle
        title="Number of columns"
        id="number-of-columns-label"
        configField="columnCount"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('columnCount')}
      />
      <SettingsSliderInput
        initialValue={initialValue}
        updateConfigCallback={updateConfigCallback}
        min={min}
        max={max}
        data-test="column-count-input"
        aria-labelledby="number-of-columns-label"
      />
    </div>
  );
};
